// ======================= Imports =======================
import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckTickBtn, Loginbg, Sniptel } from "../../../../utility";
import { Button } from "primereact/button";

// ======================= Main Component =======================
const Login = () => {
  // ======================= Router =======================
  const navigate = useNavigate();

  // ======================= Render =======================
  return (
    <div
      className="flex w-full flex-column justify-content-center align-items-center"
      style={{ height: "100vh", background: "white" }}
    >
      {/* ======================= Background ======================= */}
      <div className="bggradient flex w-full">
        <Loginbg />
      </div>
      <div
        className="flex flex-column justify-content-between align-items-center "
        style={{ width: "48.3rem", height: "56.1rem" }}
      >
        {/* ======================= Logo ======================= */}
        <div className="sniptel">
          <span>
            <Sniptel />
          </span>
        </div>
        {/* ======================= Success Message ======================= */}
        <div
          className="flex flex-column justify-content-center align-items-center forgetpasspopup "
          style={{ width: "48.3rem", height: "39.3rem" }}
        >
          <div>
            <CheckTickBtn />
          </div>
          <div className="flex flex-column align-items-center checkinbox mt-4">
            <h1>Success</h1>
            <p>
              Your password has been reset. Please log in to continue using
              Sniptel.
            </p>
            {/* ======================= Login Button ======================= */}
            <Button
              label="Login"
              type="button"
              onClick={() => navigate("/login")}
              className="forgetbtn mt-4"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
